module.exports = __webpack_public_path__ + "static/img/bottomNav.c7c3e78d.png";